<template>
  <div class="sky-hc-add-article">
    <h2 class="sky-hc-add-article__title">{{ $t('articleManage.addArticle') }}</h2>
    <el-form label-width="100px" :model="articleForm" ref="articleForm" :rules="rules">
      <el-form-item prop="coverUrl">
        <Upload
          @handleUploadFile="handleUploadFile"
          :imgUrl="articleForm.coverUrl"
          uploadClass="sky-hc-upload__uploader-article"
          size="398*148"
        ></Upload>
      </el-form-item>
      <el-form-item :label="$t('articleManage.articleTitle')" prop="title"
        ><el-input v-model="articleForm.title"></el-input
      ></el-form-item>
      <!-- <el-form-item :label="$t('articleManage.articleProfile')"><el-input type="textarea"></el-input></el-form-item> -->
      <el-form-item :label="$t('articleManage.articleAddress')" prop="url" verify>
        <el-input v-model="articleForm.url"></el-input>
      </el-form-item>
      <el-form-item :label="$t('articleManage.belongCategory')" prop="category" verify>
        <article-category-select
          v-if="categoryList.length"
          :data="categoryList"
          :actions="categoryActions"
          v-model="articleForm.category"
        />
      </el-form-item>
      <div class="sky-hc-add-article__btn-wrapper">
        <el-button @click="handleBack">{{ $t('articleManage.cancel') }}</el-button>
        <el-button type="primary" @click="handleSaveArticle(publish)">{{ $t('articleManage.save') }}</el-button>
        <el-button type="primary" @click="handleSaveArticle(true)" v-if="!publish">{{
          $t('articleManage.public')
        }}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { Form, FormItem, Input, Button, Select, Tree } from 'element-ui'

import { addArticle, updateArticle, getArticleDetail } from '@/api/articleManage'
import ArticleCategorySelect from '@/components/articleCategorySelect'
import Upload from '@/components/upload'
import category from '@/mixins/category'
import { CATEGORY_TYPE } from '@/utils/enum'
import { FormValidate } from '@/utils/formValidate'
export default {
  name: 'AddArticle',
  mixins: [category],
  components: {
    [Form.name]: Form,
    Upload,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    [Select.name]: Select,
    [Tree.name]: Tree,
    ArticleCategorySelect
  },
  data() {
    return {
      categoryActions: [
        {
          label: this.$t('articleManage.addSubNewClass'),
          icon: 'el-icon-plus',
          handler: this.handleAddSubNewCategory,
          enabled: {
            deep: {
              is: [0, 1]
            }
          }
        }
      ],
      articleForm: {
        url: '',
        category: {
          id: this.$route.query.categoryId
        }
      },
      rules: {
        url: [
          { notEmpty: 'articleManage.article_url_note_empty' },
          [
            {
              validator: FormValidate.validateURL
            }
          ]
        ],
        category: [[{ required: true, message: this.$t('articleManage.category_url_note_empty'), trigger: 'blur' }]]
      },
      publish: false
    }
  },
  computed: {
    articleId() {
      return this.$route.query.id
    },
    categoryId() {
      return this.$route.query.categoryId
    }
  },
  watch: {
    categoryList() {
      if (this.$route.query.categoryId === '0') {
        this.articleForm.category = this.categoryList[0].children[0]
        this.articleForm = Object.assign({}, this.articleForm)
      }
    }
  },
  created() {
    this.handleGetCategoryList(CATEGORY_TYPE.ARTICLE)
    if (this.articleId) {
      this.handleGetArticleInfo()
    }
  },
  methods: {
    handleBack() {
      this.$router.push({ path: '/web-manage/article-manage/article' })
    },
    handleGetArticleInfo() {
      getArticleDetail({
        id: this.articleId
      })
        .then(response => {
          this.articleForm.category.id = response.data.content.categoryId
          this.articleForm.url = response.data.content.url
          this.articleForm.coverUrl = response.data.content.coverUrl
          this.articleForm.title = response.data.content.title
          this.articleForm = Object.assign({}, this.articleForm)
          this.publish = response.data.content.publish
        })
        .catch(err => {
          console.log('err', err)
        })
    },
    handleSaveArticle(needPublish) {
      this.$refs.articleForm.validate(valid => {
        if (valid) {
          if (this.articleId) {
            this.handleEditArticle(needPublish)
          } else {
            this.handleAddArticle(needPublish)
          }
        }
      })
    },
    handleEditArticle(needPublish) {
      updateArticle({
        id: this.articleId,
        url: this.articleForm.url,
        categoryId: this.articleForm.category.id,
        publish: needPublish,
        coverUrl: this.articleForm.coverUrl,
        title: this.articleForm.title
      }).then(() => {
        this.handleBack()
      })
    },
    handleAddArticle(needPublish) {
      addArticle({
        url: this.articleForm.url,
        categoryId: this.articleForm.category.id,
        publish: needPublish,
        coverUrl: this.articleForm.coverUrl,
        title: this.articleForm.title
      }).then(() => {
        this.handleBack()
      })
    },
    handleUploadFile(url) {
      this.$set(this.articleForm, 'coverUrl', url)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-add-article) {
  @include e(title) {
    font-size: $--font-size-large;
    color: #333333;
  }
  @include e(uploader) {
    border-radius: 4px;
    border: 1px dashed $--color-primary;
    width: 398px;
    height: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
  }
  @include e(uploader-icon) {
    font-size: 40px;
    color: $--color-primary;
  }
  @include e(uploader-txt1) {
    font-size: $--size-base;
    color: $--color-grey-8;
    margin-top: 26px;
  }
  @include e(uploader-txt2) {
    font-size: $--size-base;
    color: $--color-grey-8;
    margin-top: 16px;
  }
  @include e(btn-wrapper) {
    width: 100%;
    text-align: center;
  }
}
</style>
